import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextWithTooltipComponent } from './text-with-tooltip.component';
import { TooltipDirectiveModule } from '@lib/directives/tooltip/tooltip.module';

@NgModule({
  declarations: [TextWithTooltipComponent],
  imports: [CommonModule, TooltipDirectiveModule],
  exports: [TextWithTooltipComponent],
})
export class TextWithTooltipModule {}